import { useMemo } from 'react'
import { Button, LocalIcon, Tooltip } from '~/shared/ui'
import { useAuditTrail } from '../model'

export function AuditTrailButton() {
  const { isAuditTrailVisible, openAuditTrail, closeAuditTrail, disabledMessage } = useAuditTrail()

  const button = useMemo(() => {
    return (
      <Button
        onClick={isAuditTrailVisible ? closeAuditTrail : openAuditTrail}
        disabled={!!disabledMessage}
      >
        <span className="flex items-center gap-1.5">
          <LocalIcon name="time" />
          <span>Audit Trail</span>
        </span>
      </Button>
    )
  }, [isAuditTrailVisible, closeAuditTrail, openAuditTrail, disabledMessage])

  if (disabledMessage) {
    return (
      <Tooltip content={disabledMessage}>
        <div>{button}</div>
      </Tooltip>
    )
  }

  return button
}
